import { Button, ButtonAppearance, inputMediumStyles, SideSheetHeader, SideSheetClose, Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { SearchField } from '@bechtel/client-common';

export const SearchFieldComponentStyled = styled(SearchField)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[300]}!important;
    color: ${theme.colors.grey[1000]}!important;
    @media only screen and (max-width: ${theme.breakpoints.widescreen}) {
      ${inputMediumStyles}
    }
  `}
`;
export const SearchContainerBoxStyled = styled(Box).attrs({
  p: { sm: '450' },
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const ColumnHeaderBoxStyled = styled(Box).attrs({
  py: { sm: '500' },
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
  mx: { sm: '500' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
  `}
`;

export const ListStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  overflow-y: auto;
`;

export const HeaderStyled = styled(SideSheetHeader)`
  ${({ theme }) =>
    css`
      background-color: ${theme.colors.white};
      color: ${theme.colors.grey[1000]};
      padding: ${theme.spacings[700]} ${theme.spacings[500]};
    `}
`;

export const CloseStyled = styled(SideSheetClose).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) =>
    css`
      color: ${theme.colors.bechtel.blue[800]};
      border: none;
      margin-top: ${theme.spacings[450]};
    `}
`;

export const FooterButtonStyled = styled(Button).attrs({ appearance: ButtonAppearance.SECONDARY })`
  ${({ theme }) => css`
    font-weight: ${theme.fontWeights[600]};
    color: ${theme.colors.bechtel.blue[800]};
    padding-right: ${theme.spacings[600]};
    padding-left: ${theme.spacings[600]};
    width: auto;
  `}
`;
